<template>
  <v-icon small v-text="statusPedido" :color="statusCor"></v-icon>
</template>

<script>
export default {
  name: 'StatusIcon',
  props: {
    status: {
      type: String,
      default: 'A'
    }
  },
  computed: {
    statusPedido() {
      if (this.status.startsWith('A')) return 'mdi-checkbox-blank-circle';
      if (this.status.startsWith('O')) return 'mdi-checkbox-blank-circle';
      if (this.status.startsWith('F')) return 'mdi-checkbox-blank-circle';
      return 'mdi-checkbox-blank-circle-outline';
    },
    statusCor() {
      if (this.status.startsWith('O')) return 'warning';
      if (this.status.startsWith('A')) return 'success';
      if (this.status.startsWith('F')) return 'success';
      return '';
    }
  }
}
</script>

<style>

</style>